import React from 'react';
import '../../../styles/Mohacs500.css';
import BackButtonPage from '../../../components/BackButtonPage';


function Mohacs500() {
  return (
    <div className='page-content-container'>
      {/* <div className='mohacs-title'>
        A „három éves terv” avagy az Egy hajóban… projekt munkaterv összefoglalója a <br />
        2024-es, 2025-ös és 2026-os esztendőkre
      </div>
      <p>
        2024-ben egy korhű dereglyével végigevezzük a történelmi zarándoklat Ercsi-Mohács Duna 
        szakaszát és részt veszünk a megemlékezésekben. <br />
        <Link className='tura-osszefoglalo'>(Ez a túra nagy sikerrel lezajlott. A program összefoglalója itt tekinthető meg.)</Link>
      </p>
      <p>
        A 2025-ös esztendőben már az emlékévre előkészítő munkáké a főszerep.
        <ul className='mohacs-list'>
          <li className='mohacs-list-item'>
            Az év elején közreadunk egy történelmi életmód rekonstrukciós segédletet, amely 
            szakmai háttéranyagként szolgálhat a XV.-XVI. század fordulójának hadihagyományőrző 
            megjelenítéséhez, különös tekintettel a korszak hajóskatonáira, az úgynevezett “királynaszádosokra”.
          </li>
          <li className='mohacs-list-item'>
            Országos kampányt indítunk annak érdekében, hogy minden vármegye képviseltesse 
            magát a történelmi hajós zarándoklatban, egy a területén működő történelmi 
            hagyományőrzőkből és cserkészekből összeállított csoportot delegálva. 
          </li>
          <li className='mohacs-list-item'>
            A 2025-ös Mohácsi zarándoktúrát Buda alól indulva járjuk végig, egy korhű evezős 
            naszáddal. A túra résztvevői a korszak hajóskatonáinak viseleteiben és eszközeik pontos 
            rekonstrukcióit használva teszik meg az utat.
          </li>
          <li className='mohacs-list-item'>
            Ösztönözzük az útvonal településeinek aktív együttműködését a zarándoklat programjaiban 
            és lehetőség szerint igyekszünk bevonni az érintett települések iskoláit-diákcsoportjait. 
          </li>
          <li className='mohacs-list-item'>
            Szeretnénk a hajóstúra nyolc kikötőállomásán (Érd-Százhalombatta, Ercsi, Dunaújváros, 
            Dunaföldvár, Kalocsa-Foktő, Baja, Dunaszekcső, Mohács) a II. Lajos korát idéző sátortáborral 
            és a korszakot idéző programokkal készülni az emlékév majdani eseményeire. 
            Teszteljük a kikötési helyszíneket, az egyes programelemek hajótúrához való integrálhatóságát 
            és a színrevitelük realitásait. Szándékunk szerint a haditábor, az érintett települések 
            számára nyitott és ingyenesen látogatható eseményként egyfajta vándorrendezvény 
            lenne, amelyben íjász- és számszeríjász bemutatók, kézműves foglakozások és vásár, 
            bajvívó vetélkedés, a korabeli ágyúk és puskák szemléltetése, élő históriás zenei előadások, 
            hajítógépek, középkori játékok és ügyességi feladatok során ismerkedhetnek meg a 
            Mohácsi csata világával és a történelmi életmód rekonstrukciós műfajjal az érdeklődők. 
          </li>
          <li className='mohacs-list-item'>
            Elkezdjük a „naszádflotta” hajóinak elkészítését. Reményeink szerint minden vármegye 
            részt vesz a nagy történelmi regattában. Kiállítanak egy-egy naszádnyi legénységet a 
            területükön tevékenykedő hagyományőrzőkből és cserkészekből. Egészen egyedülálló 
            lehetőség, és kiemelkedő erejű demonstráció lenne, ha ennek kapcsán mind a 19 vármegyének 
            elkészíthetnénk azt a történelmi hajórekonstrukciót, amellyel részt vehetnek a 
            Buda-Mohács hajós zarándoklatban.
          </li>
        </ul>
      </p>
      <p>
        2026-ban, a Mohácsi csata emlékévében, a Mohácsi Nemzeti Emlékhelyet üzemeltető 
        DDNPI által 10. alkalommal megrendezendő történelmi zarándoklat és az azévben 14. éves 
        Egy Hajóban… kezdeményezés összeáll egy egészen egyedülálló programmá. 
      </p>
      <p>
        A teljes nemzetet képviselő legénységű Királyi Naszád vezetésével, a 19 vármegye korhű 
        hajói és a többi csatlakozó történelmi hajós csoport összeállnak egy nagy történelmi zarándokflottává, 
        amely az augusztus 20.-i ünnepi tűzijáték fényeivel övezve, a Budai vár alól indul 
        Mohácsig tartó evezős útjára. 
        <ul className='list'>
          <li className='list-item'>
            Az Augusztus 20.-i Nemzeti Ünnepnek sokáig szerves része volt a Parlament előtti Dunaszakaszon 
            zajló hadihajós felvonulás, a vízi- és légiparádé. A 2026-os esztendő, mint a 
            Mohácsi csata 500. évfordulója, kiváló alkalmat teremt ennek az eseménynek új tartalommal 
            feltöltésére és hagyomány-újrateremtő megvalósítására, a Történelmi Zarándokflotta 
            szerepeltetése által.
          </li>
          <li className='list-item'>
            Az ünnepnap záróeseménye a tűzijáték, amelynek nyitóképeként a Történelmi Zarándokflotta 
            fáklyafényben fürdő hajói beeveznek a Budai vár és a Parlament közé. Elöl a Királyi 
            Naszád, mögötte hosszú rajokban a 19 vármegye zászlai alatt hajózó naszádok és a folyami 
            dereglyék sokasága. A helyszínen kihangosított narráció és a televíziós közvetítés 
            teszi teljessé a kezdeményezés üzeneteit. A megfelelő pillanatban a naszádok ágyúinak 
            díszlövése adja meg a jelet a tüzijáték indítására. A Történelmi Zarándokflotta a tüzijáték 
            varázsfényei alatt siklik tova a Duna habjain az első táborhely felé…
          </li>
          <li className='list-item'>
            A regatta résztvevői a kilencnapos hajóút minden állomásán II. Lajos hadát felidéző, korhű 
            sátortáborba szállnak, korismereti rendezvényként látogathatóvá téve a haditábort. 
            Tisztelegnek az un. „Lajos köveknél” (a csatába vonuló had útvonalának jelesebb állomásain 
            felállított emlékműveknél) így járja végig többszáz hagyományfelelevenítő a török 
            ellen vonuló had egykori útvonalát, az össznemzeti együttműködést, az összefogás erejét 
            demonstrálva, és ismeretterjesztő módon tisztelegve a Mohácsi csata hősei előtt 
          </li>
          <li className='list-item'>
            Mohácsra érkezvén, egy nagy korismereti találkozóval – történelmi rendezvénnyel zárul 
            a zarándok regatta.
          </li>
        </ul>
      </p>
      <p>
        A Történelmi Zarándokflotta igyekszik méltó emléket állítani a magyar királyi had folyami 
        flottájának, amely anno a felszerelést, az ágyúkat és az élelmet szállította a muzulmán hódítók 
        roppant serege ellen vonuló keresztény had részeként. 
        Kifejezett szándékunk e több elemből álló projekt kezdeményezésével a naprakész történelmi 
        eredmények közvetítésén és a megemlékezésen, a tisztelgő főhajtáson túl, egy széles 
        társadalmi rétegekhez szóló, példaadó metódus- valamint elsőrendűen fontos értékek 
        képviselete, egy a későbbiekben is hosszútávon működő hagyomány indítása.
      </p> */}

      <p>
        Az új bázishelyszínünkön, Adonyban talált ránk 2023-ban, a 2016-óta folyamatosan 
        minden évben megrendezett Mohács-emléktúra szervezőinek ötlete, miszerint egy 
        középkori hajónkkal vegyünk részt a kezdeményezésükben és a Dunán kísérjük végig 
        a történelmi zarándoklatuk lovastúráját. Eger Gabriella, a túra lovasainak képviseletében 
        látogatott el hozzánk és elmesélte, hogy a Dr Négyesi Lajos hadtörténész professzor 
        által indított (és minden évben végigjárt) zarándoktúra a II. Lajos Mohácsra 
        vonuló hadának útját jelző emlékművek mentén zajlik, több lovasegyesület részvételével. 
        Mivel ez az út a Duna menti települések során vezet keresztül, adta magát 
        számukra az ötlet, hogy a kerékpáros, gyalogos és lovas zarándokok mellett járja végig 
        egy evezős hajó is a zarándoklatot. (A túra hajós vonatkozásának történelmi háttere, 
        hogy a Mohácsi csatasíkra igyekvő magyar királyi hadat naszádokból, és egyéb hajókból 
        álló flotta kísérte az oszmán birodalom roppant serege elleni hősies, ámde végzetes 
        csatájába.)
      </p>
      <p>
        Természetesen örömmel csatlakoztunk ehhez az emléktúrához. Olyannyira, hogy 
        kidolgoztunk egy hároméves munkatervet, amelynek mentén ennek keretében folytatjuk 
        az Egy hajóban… programot.
        Megállapodtunk a Mohácsi Nemzeti Emlékhelyet kezelő DDNPI vezető munkatársával, 
        Varga Zsolttal (aki a Mohácsi Nemzeti Emlékhely részéről nyolcadik éve főszervezője 
        a történelmi zarándoklatnak), hogy Történelmi hajós projektünkkel csatlakozva ehhez 
        a szép kezdeményezéshez, igyekszünk felidézni a Mohácsi csatába vonuló királyi had 
        Dunai flottakíséretét, hajós hagyományőrző mozgalmat generálva, létrehozva egy, a 
        történelmi/néprajzi értékeinket népszerűsítő flotillát.
      </p>
      <p>
        A hagyományőrző zarándoklattal való együttműködés első alkalma rendkívül sikeres volt.
        Eről az eseményről facebook oldalunkon tettünk közé egy összefoglalót:
      </p>
      <a href="https://www.facebook.com/media/set?vanity=EgyHajobanEvezunk&set=a.934378758733425" target="_blank" rel="noopener noreferrer">
        <img src="/assets/mohacs500.png" className='mohacs500-img' alt="Mohács 500" />
      </a>
      <BackButtonPage to="/projekt" />
    </div>

  );
}

export default Mohacs500;
